var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16zm7.337-20.77a7.96 7.96 0 002.263-.611 7.95 7.95 0 01-1.966 2.008c.007.166.01.334.01.502 0 5.126-3.96 11.037-11.206 11.037-2.225 0-4.295-.642-6.038-1.742.309.036.623.054.94.054 1.846 0 3.544-.62 4.892-1.661a3.937 3.937 0 01-3.68-2.694 3.998 3.998 0 001.779-.067c-1.802-.356-3.16-1.924-3.16-3.804v-.049c.532.29 1.14.465 1.785.486a3.861 3.861 0 01-1.752-3.229c0-.712.194-1.378.533-1.95a11.24 11.24 0 008.119 4.053 3.864 3.864 0 01-.102-.884c0-2.142 1.763-3.879 3.939-3.879 1.132 0 2.156.471 2.874 1.225a7.971 7.971 0 002.502-.941 3.897 3.897 0 01-1.732 2.146z",
    fill: "#fff"
  })));
}
export default SvgTwitterIcon;